module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ro-33482fcd4344b097d6d7108dc38ed79f.svg";